import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import { FormattedMessage } from "react-intl";
import { useNetwork } from "../NetworkProvider";

interface NavigatorMenuItemProps {
    isActivePage: boolean;
    icon: React.ReactNode;
    link: string | null;
    menuItemName: string;
    setShowNotifications: React.Dispatch<React.SetStateAction<boolean>> | null;
    showNotifications: boolean;
    children: React.ReactNode;
}

const NavigatorMenuItem = ({
    isActivePage,
    icon,
    link,
    menuItemName,
    showNotifications,
    setShowNotifications,
    children,
}: NavigatorMenuItemProps) => {
    const { getUserNotifications, isOnline } = useNetwork();
    const navigate = useNavigate();

    const handleClick = () => {
        if (isOnline && !showNotifications && link) {
            getUserNotifications();
        }
        if (link) {
            navigate(`/${link}`);
            setShowNotifications(false);
        } else {
            setShowNotifications((prev) => !prev);
        }
    };

    const menuButton = "relative py-3 hover:bg-white hover:text-lg";
    const activeMenuButton = "relative py-3 bg-white font-semibold text-lg";
    const labelStyle =
        "absolute bottom-0 pb-4 h-1 w-full text-center -translate-y-3/4 text-xs";
    return (
        <div
            className={isActivePage ? activeMenuButton : menuButton}
            onClick={handleClick}
        >
            <MenuItem
                icon={icon}
                component={link && <Link to={`/${link}`} />}
            />

            <div className={labelStyle}>
                <FormattedMessage id={menuItemName} values={{ number: 1 }} />{" "}
                {children}
            </div>
        </div>
    );
};

export default NavigatorMenuItem;
